export default "__VITE_ASSET__88tBWBZ$__"